module.exports = __webpack_public_path__ + "img/menu-barra.56231906.svg";